import { render, staticRenderFns } from "./getorder.vue?vue&type=template&id=6586d01c&"
import script from "./getorder.vue?vue&type=script&lang=ts&"
export * from "./getorder.vue?vue&type=script&lang=ts&"
import style0 from "./getorder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports